<template>
  <button :disabled="loading || disabled" class="flex items-center">
    <div v-if="loading" class="btn-spinner mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    disabled: {
    	type: Boolean,
    	default: false
    }
  },
}
</script>
